(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["menu"] = factory(require("@splat/constant"), require("@splat/theme"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"));
	else
		root["menu"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/item.tsx":
/*!**********************!*\
  !*** ./src/item.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MenuItem": function() { return /* binding */ MenuItem; },
/* harmony export */   "SubMenuItem": function() { return /* binding */ SubMenuItem; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};









var MenuItem = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(MenuItem, _tsx$Component);

  var _super = _createSuper(MenuItem);

  function MenuItem() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, MenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "index", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "actived", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "itemNum", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "hasSubMenu", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "aItem", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "firstChild", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_menuDirection", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(MenuItem, [{
    key: "menuDirection",
    get: function get() {
      return this._menuDirection();
    }
  }, {
    key: "ActiveClassName",
    get: function get() {
      var theme = this.theme,
          menuDirection = this.menuDirection;
      return menuDirection === _types__WEBPACK_IMPORTED_MODULE_11__.Direction.horizontal ? _style__WEBPACK_IMPORTED_MODULE_10__.majorMenuActiveClassName(theme) : _style__WEBPACK_IMPORTED_MODULE_10__.minorMenuActiveClassName;
    }
  }, {
    key: "onClick",
    value: function onClick() {
      return this.index;
    }
  }, {
    key: "handleBeforeEnter",
    value: function handleBeforeEnter(e) {
      var el = e;
      el.style.cssText += "height:0px;opacity:0";
    }
  }, {
    key: "handleEnter",
    value: function handleEnter(e, done) {
      var _this2 = this;

      setTimeout(function () {
        var el = e;
        el.style.cssText += "height:".concat(40 * _this2.itemNum + _splat_constant__WEBPACK_IMPORTED_MODULE_8__.MenuSizes.themeSubMenuPaddingTop(_this2.theme) + _splat_constant__WEBPACK_IMPORTED_MODULE_8__.MenuSizes.themeSubMenuPaddingBottom(_this2.theme), "px;opacity:1");
      }, 0);
      e.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "handleBeforeLeave",
    value: function handleBeforeLeave(e) {
      var el = e;
      el.style.opacity = '1';
    }
  }, {
    key: "handleLeave",
    value: function handleLeave(e, done) {
      setTimeout(function () {
        var el = e;
        el.style.cssText += "height:0px;opacity:0";
      }, 0);
      e.addEventListener('transitioned', done, {
        once: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var actived = this.actived,
          menuDirection = this.menuDirection,
          onClick = this.onClick,
          ActiveClassName = this.ActiveClassName,
          hasSubMenu = this.hasSubMenu,
          index = this.index,
          aItem = this.aItem,
          firstChild = this.firstChild;
      var showSubMenu = menuDirection === _types__WEBPACK_IMPORTED_MODULE_11__.Direction.vertical && this.$slots.submenu;
      return h("li", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.menuItemContainer, actived && !showSubMenu && 'actived', !showSubMenu && actived && ActiveClassName, showSubMenu && actived && _style__WEBPACK_IMPORTED_MODULE_10__.parentActiveClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item'), menuDirection === _types__WEBPACK_IMPORTED_MODULE_11__.Direction.vertical && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'vertical'), hasSubMenu && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'hasSubMenu')),
        "on": {
          "click": aItem ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)(onClick) : (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.eventStop)(onClick)
        }
      }, [aItem ? h("a", {
        "attrs": {
          "href": firstChild ? "".concat((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.routerModeUrl)(this.$router)).concat(firstChild.replace(/:/g, '/')) : "".concat((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.routerModeUrl)(this.$router)).concat(index.replace(/:/g, '/'))
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.menuItemContentClassName, _style__WEBPACK_IMPORTED_MODULE_10__.menuLinkItemClassName, aItem && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'aItem'), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'content'), hasSubMenu && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'hasSubMenu_content'))
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.minorMenuItemContentTextClassName, !showSubMenu && _style__WEBPACK_IMPORTED_MODULE_10__.menuItemContentTextClassName)
      }, [this.$slots.default]), showSubMenu ? h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)('el-icon-arrow-down', _style__WEBPACK_IMPORTED_MODULE_10__.menuItemIconClassName, actived && _style__WEBPACK_IMPORTED_MODULE_10__.menuItemIconRotateClassName)
      }) : null]) : h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.menuItemContentClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'content'), hasSubMenu && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu-item', 'hasSubMenu_content'))
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.minorMenuItemContentTextClassName, !showSubMenu && _style__WEBPACK_IMPORTED_MODULE_10__.menuItemContentTextClassName)
      }, [this.$slots.default]), showSubMenu ? h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)('el-icon-arrow-down', _style__WEBPACK_IMPORTED_MODULE_10__.menuItemIconClassName, actived && _style__WEBPACK_IMPORTED_MODULE_10__.menuItemIconRotateClassName)
      }) : null]), h("transition", {
        "attrs": {
          "appear": true,
          "enterActiveClass": _style__WEBPACK_IMPORTED_MODULE_10__.subMenuActive,
          "leaveActiveClass": _style__WEBPACK_IMPORTED_MODULE_10__.subMenuActive
        },
        "on": {
          "beforeEnter": this.handleBeforeEnter,
          "enter": this.handleEnter,
          "beforeLeave": this.handleBeforeLeave,
          "leave": this.handleLeave
        }
      }, [showSubMenu && actived ? this.$slots.submenu : null])]);
    }
  }]);

  return MenuItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], MenuItem.prototype, "index", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], MenuItem.prototype, "actived", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], MenuItem.prototype, "itemNum", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], MenuItem.prototype, "hasSubMenu", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], MenuItem.prototype, "aItem", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], MenuItem.prototype, "firstChild", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Inject)('menuDirection')], MenuItem.prototype, "_menuDirection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('click')], MenuItem.prototype, "onClick", null);

MenuItem = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], MenuItem);


var SubMenuItem = /*#__PURE__*/function (_tsx$Component2) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(SubMenuItem, _tsx$Component2);

  var _super2 = _createSuper(SubMenuItem);

  function SubMenuItem() {
    var _this3;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, SubMenuItem);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this3), "index", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this3), "actived", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this3), "aItem", void 0);

    return _this3;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(SubMenuItem, [{
    key: "onClick",
    value: function onClick() {
      return this.index;
    }
  }, {
    key: "render",
    value: function render() {
      var h = arguments[0];
      var onClick = this.onClick,
          actived = this.actived,
          aItem = this.aItem;
      return h("li", {
        "on": {
          "click": aItem ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.preventStop)(onClick) : (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.eventStop)(onClick)
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_12__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.menuItemSubMenuItemClassName, actived && _style__WEBPACK_IMPORTED_MODULE_10__.menuItemSubMenuActiveClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('SubMenuItem'), actived && (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('SubMenuItem', 'actived'))
      }, [this.$slots.default]);
    }
  }]);

  return SubMenuItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], SubMenuItem.prototype, "index", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: false
})], SubMenuItem.prototype, "actived", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], SubMenuItem.prototype, "aItem", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('click')], SubMenuItem.prototype, "onClick", null);

SubMenuItem = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component], SubMenuItem);


/***/ }),

/***/ "./src/menu.tsx":
/*!**********************!*\
  !*** ./src/menu.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Menu": function() { return /* binding */ Menu; },
/* harmony export */   "SubMenu": function() { return /* binding */ SubMenu; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_15__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};










var Menu = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(Menu, _tsx$Component);

  var _super = _createSuper(Menu);

  function Menu() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, Menu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "direction", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "verticalMenuMaxWidth", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(Menu, [{
    key: "provideDirection",
    value: function provideDirection() {
      return this.direction;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var h = arguments[0];
      var direction = this.direction,
          theme = this.theme,
          verticalMenuMaxWidth = this.verticalMenuMaxWidth,
          i18nInjection = this.i18nInjection;

      var horizontalMenu = function horizontalMenu() {
        return h("ul", {
          "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.majorMenuContainer(theme), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu', 'horizontal'))
        }, [_this2.$slots.default]);
      };

      var verticalMenu = function verticalMenu() {
        return h("ul", {
          "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.minorMenuContainer(theme, i18nInjection.lang), verticalMenuMaxWidth && _style__WEBPACK_IMPORTED_MODULE_10__.minorMenuMaxWidthClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu', 'vertical'))
        }, [_this2.$slots.header ? h("li", {
          "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.minorMenuHeader, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu', 'vertical_header'))
        }, [_this2.$slots.header]) : null, _this2.$slots.default]);
      };

      return direction === 'horizontal' ? horizontalMenu() : verticalMenu();
    }
  }]);

  return Menu;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)({
  default: _types__WEBPACK_IMPORTED_MODULE_11__.Direction.vertical
})], Menu.prototype, "direction", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Prop)()], Menu.prototype, "verticalMenuMaxWidth", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Provide)('menuDirection')], Menu.prototype, "provideDirection", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Inject)({
  from: 'i18nInjection',
  default: null
})], Menu.prototype, "i18nInjection", void 0);

Menu = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], Menu);


var SubMenu = /*#__PURE__*/function (_tsx$Component2) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(SubMenu, _tsx$Component2);

  var _super2 = _createSuper(SubMenu);

  function SubMenu() {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, SubMenu);

    return _super2.apply(this, arguments);
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(SubMenu, [{
    key: "render",
    value: function render() {
      var h = arguments[0];
      return h("ul", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.menuItemSubMenuClassName(this.theme), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu', 'subMenu'))
      }, [h("li", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_10__.showCompleteBoxShadow, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('menu', 'subMenu_item'))
      }), this.$slots.default]);
    }
  }]);

  return SubMenu;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_13__.Component);

SubMenu = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_12__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], SubMenu);


/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "menuItemContainer": function() { return /* binding */ menuItemContainer; },
/* harmony export */   "menuItemContentClassName": function() { return /* binding */ menuItemContentClassName; },
/* harmony export */   "minorMenuItemContentTextClassName": function() { return /* binding */ minorMenuItemContentTextClassName; },
/* harmony export */   "menuItemContentTextClassName": function() { return /* binding */ menuItemContentTextClassName; },
/* harmony export */   "menuItemIconClassName": function() { return /* binding */ menuItemIconClassName; },
/* harmony export */   "menuItemIconRotateClassName": function() { return /* binding */ menuItemIconRotateClassName; },
/* harmony export */   "menuItemSubMenuClassName": function() { return /* binding */ menuItemSubMenuClassName; },
/* harmony export */   "menuItemSubMenuItemClassName": function() { return /* binding */ menuItemSubMenuItemClassName; },
/* harmony export */   "menuItemSubMenuActiveClassName": function() { return /* binding */ menuItemSubMenuActiveClassName; },
/* harmony export */   "menuContainer": function() { return /* binding */ menuContainer; },
/* harmony export */   "majorMenuContainer": function() { return /* binding */ majorMenuContainer; },
/* harmony export */   "majorMenuActiveClassName": function() { return /* binding */ majorMenuActiveClassName; },
/* harmony export */   "minorMenuHeader": function() { return /* binding */ minorMenuHeader; },
/* harmony export */   "minorMenuContainer": function() { return /* binding */ minorMenuContainer; },
/* harmony export */   "minorMenuMaxWidthClassName": function() { return /* binding */ minorMenuMaxWidthClassName; },
/* harmony export */   "minorMenuActiveClassName": function() { return /* binding */ minorMenuActiveClassName; },
/* harmony export */   "subMenuActive": function() { return /* binding */ subMenuActive; },
/* harmony export */   "showCompleteBoxShadow": function() { return /* binding */ showCompleteBoxShadow; },
/* harmony export */   "cloudMinorMenuClassName": function() { return /* binding */ cloudMinorMenuClassName; },
/* harmony export */   "parentActiveClassName": function() { return /* binding */ parentActiveClassName; },
/* harmony export */   "menuLinkItemClassName": function() { return /* binding */ menuLinkItemClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var menuItemContainer = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.menuItemTransition, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0, (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorItemPadding)), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0, (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorItemMargin)), {
  position: 'relative',
  cursor: 'pointer',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
});
var menuItemContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center);
var minorMenuItemContentTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flex);
var menuItemContentTextClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100)
});
var menuItemIconClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.content, _splat_constant__WEBPACK_IMPORTED_MODULE_1__.iconTransition, {
  transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(0)),
  '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(0)),
  marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12)
});
var menuItemIconRotateClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "&.".concat(menuItemIconClassName), {
    transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(180)),
    '-webkit-transform': (0,csx__WEBPACK_IMPORTED_MODULE_3__.rotateZ)((0,csx__WEBPACK_IMPORTED_MODULE_3__.deg)(180))
  })
});
var menuItemSubMenuClassName = function menuItemSubMenuClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0), {
    listStyle: 'none',
    background: '#FBFBFB',
    position: 'relative',
    $nest: {
      '& > li:nth-child(2)': {
        marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.themeSubMenuPaddingTop(theme))
      },
      '& > li:last-child': {
        marginBottom: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.themeSubMenuPaddingBottom(theme))
      }
    }
  });
};
var menuItemSubMenuItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'relative',
  paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorItemPadding + 12),
  paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorItemPadding),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(40),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorFont.toString(),
  $nest: {
    '&:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlightFont.toString()
    }
  }
});
var menuItemSubMenuActiveClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  background: '#F5F5F5',
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlightFont.toString()
});
var menuContainer = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.layerParent, {
  listStyle: 'none',
  margin: 0,
  paddingLeft: 0,
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorFontSize)
});
var majorMenuContainer = function majorMenuContainer(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.classes)(menuContainer, (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0), {
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.majorFont.toString(),
    height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorHeight),
    lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorHeight),
    $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "& > .".concat(menuItemContainer), {
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorHeight),
      boxSizing: 'border-box',
      paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorItemPadding),
      float: 'left',
      $nest: {
        '&:hover': {
          background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.themeMajorHighlight(theme).toString(),
          color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.majorHighlightFont.toString()
        }
      }
    })
  }));
};
var majorMenuActiveClassName = function majorMenuActiveClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.themeMajorHighlight(theme).toString(),
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.majorHighlightFont.toString()
  });
};
var minorMenuHeader = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0, _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorHeaderPadding), {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.zoneHeight),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.zoneHeight),
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHeaderFont.toString()
});
var minorMenuContainer = function minorMenuContainer(theme, lang) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.classes)(menuContainer, (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorFont.toString(),
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorFontSize),
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.themeMinorWidth(theme, lang)),
    height: 'auto',
    lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.themeMinorItemHeight(theme)),
    $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, "& > .".concat(menuItemContainer), _objectSpread(_objectSpread(_objectSpread({
      boxSizing: 'border-box'
    }, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0)), (0,csstips__WEBPACK_IMPORTED_MODULE_2__.margin)(0)), {}, {
      $nest: (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({
        '&:hover': {
          color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlightFont.toString()
        }
      }, "& > .".concat(menuItemContentClassName), {
        paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorItemPadding),
        paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.majorItemPadding)
      })
    }))
  }));
};
var minorMenuMaxWidthClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorMaxWidth)
});
var minorMenuActiveClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlightFont.toString(),
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlight.toString()
});
var subMenuActive = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  transition: 'all .6s',
  overflow: 'hidden'
});
var showCompleteBoxShadow = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
  pointerEvents: 'none',
  position: 'absolute',
  boxShadow: 'inset 0 2px 8px 0 rgba(0,0,0,0.09)'
});
var cloudMinorMenuClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorCloudWidth),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuSizes.minorCloudItemHeight)
});
var parentActiveClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.MenuColors.minorHighlightFont.toString()
});
var menuLinkItemClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  textDecoration: 'none',
  color: 'inherit'
});

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Direction": function() { return /* binding */ Direction; }
/* harmony export */ });
var Direction;

(function (Direction) {
  Direction["vertical"] = "vertical";
  Direction["horizontal"] = "horizontal";
})(Direction || (Direction = {}));

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _menu__WEBPACK_IMPORTED_MODULE_0__.Menu; },
/* harmony export */   "SubMenu": function() { return /* reexport safe */ _menu__WEBPACK_IMPORTED_MODULE_0__.SubMenu; },
/* harmony export */   "Item": function() { return /* reexport safe */ _item__WEBPACK_IMPORTED_MODULE_1__.MenuItem; },
/* harmony export */   "SubMenuItem": function() { return /* reexport safe */ _item__WEBPACK_IMPORTED_MODULE_1__.SubMenuItem; },
/* harmony export */   "Direction": function() { return /* reexport safe */ _types__WEBPACK_IMPORTED_MODULE_2__.Direction; }
/* harmony export */ });
/* harmony import */ var _menu__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./menu */ "./src/menu.tsx");
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./item */ "./src/item.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./types */ "./src/types.ts");



}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map